import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProviderType, SecurityService } from 'common';

@Component({
  selector: 'acc-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
  accountCode: string;
  accountName: string;
  erauReference: string;
  contactName: string;
  contactEmail: string;
  showSwitchUser: boolean;
  showManageProfile: boolean;
  isSuperUser: boolean;

  constructor(
    private security: SecurityService,
    private router: Router
  ) {
    this.isSuperUser = security.isSuperUser;
    this.accountCode = security.profile.selectedAccount.accountCode;
    this.accountName = security.profile.selectedAccount.accountName;
    this.erauReference = security.profile.erauReference;
    this.contactName = security.profile.user.name;
    this.contactEmail = security.profile.user.email;
    this.showSwitchUser = this.isSuperUser || security.profile.user.accounts.length > 1;
    this.showManageProfile = security.apiClientType !== 'SenderId';
  }

  navigateAndClose(): void {
    this.close();

    let url = '';
    if (this.security.profile.selectedAccount.providerType === ProviderType.SENDERID) {
      url = '/registrations/mine';
    } else {
      url = '/accounts/details/company';
    }

    this.router.navigate([{ outlets: { profilePopup: null } }]).then(() => {
      this.router.navigateByUrl(url);
    });
  }

  switchUserAndClose(): void {
    this.security.switchSelectedAccount();
    this.close();
    this.router.navigateByUrl('/accounts/login?reason=switch');
  }

  logoutAndClose(): void {
    this.close();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigateByUrl('/?reason=logout');
  }

  manageProfile(): void {
    this.close();
    this.router.navigateByUrl('/profile');
  }

  close(): void {
    this.router.navigate([{ outlets: { profilePopup: null } }]);
  }
}
